import useFeatureFlags from '@hooks/useFeatureFlags';
import {useParamInSessionStorage} from '@hooks/useParamInSessionStorage';

export const useIsLxpAdmin = () => {
  const {isFeatureFlagOn} = useFeatureFlags();
  return useParamInSessionStorage(isFeatureFlagOn.IsLxpAdmin, 'lxpAdmin');
};
